/*
  Frequently Bought Together
  Used by: snippets/frequently-bought.liquid (Product information block)
*/
(function () {
  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    format = format || '{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    function fmt(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  /* Shared add-to-cart helper (used by frequently-bought.js and sticky-atc.js).
     AJAX add: no page reload, no URL change. Opens the cart drawer and updates the header cart count. */
  window.vcAddToCart = window.vcAddToCart || function (id, qty) {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: id,
        quantity: qty || 1,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Could not add');

        /* Header cart count */
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections && res.sections['cart-icon-bubble']) {
          var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          var el = doc.querySelector('.shopify-section');
          if (el) bubble.innerHTML = el.innerHTML;
        }

        /* Cart drawer (opens it) */
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && res.sections && res.sections['cart-drawer']) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        }

        /* Small bounce on the cart icon */
        if (bubble && bubble.animate) {
          bubble.animate(
            [{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(0.95)' }, { transform: 'scale(1)' }],
            { duration: 500, easing: 'ease-out' }
          );
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vc-addon', productVariantId: id, cartData: res });
        }
        return res;
      });
  };

  var ICON = {
    plus: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    spin: '<svg class="fbt-spin" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 3a9 9 0 1 1-9 9"/></svg>',
    chevron: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
  };

  function init(root) {
    if (root.dataset.ready) return;
    var cfgEl = root.querySelector('[data-fbt-config]');
    if (!cfgEl) return;
    root.dataset.ready = '1';

    var cfg = JSON.parse(cfgEl.textContent);
    var list = root.querySelector('.fbt-list');
    var nav = root.querySelector('.fbt-nav');
    var prev = root.querySelector('.fbt-prev');
    var next = root.querySelector('.fbt-next');
    var page = 0;
    var items = [];
    var added = {};

    function firstVariant(p) {
      return p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    }

    function priceHtml(v) {
      var html = formatMoney(v.price, cfg.money);
      if (cfg.compare && v.compare > v.price) html += '<s>' + formatMoney(v.compare, cfg.money) + '</s>';
      return html;
    }

    function setButton(btn, state) {
      var icon = state === 'loading' ? ICON.spin : state === 'added' ? ICON.check : ICON.plus;
      var text = state === 'added' && cfg.added ? cfg.added : cfg.add;
      btn.innerHTML = icon + '<span>' + esc(text) + '</span>';
      btn.classList.toggle('is-loading', state === 'loading');
      btn.classList.toggle('is-added', state === 'added');
      var spin = btn.querySelector('.fbt-spin');
      if (spin && spin.animate) spin.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], { duration: 700, iterations: Infinity });
    }

    function cardHtml(p) {
      var v = firstVariant(p);
      var select = '';
      if (cfg.showVariant && p.variants.length > 1) {
        select = '<label class="fbt-variant"><span>' + esc(v.title) + '</span>' + ICON.chevron +
          '<select aria-label="' + esc(p.title) + '">' +
          p.variants.map(function (x) {
            return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + '</option>';
          }).join('') +
          '</select></label>';
      }
      var isAdded = !!added[p.id];
      return '<div class="fbt-card" data-id="' + p.id + '">' +
        (p.image ? '<a class="fbt-img" href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="' + cfg.img + '" height="' + cfg.img + '" loading="lazy"></a>' : '') +
        '<div class="fbt-info">' +
          '<a class="fbt-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          select +
          '<span class="fbt-price">' + priceHtml(v) + '</span>' +
        '</div>' +
        '<button type="button" class="fbt-add' + (isAdded ? ' is-added' : '') + '" data-variant="' + v.id + '" aria-label="' + esc(cfg.add + ' ' + p.title) + '"' + (v.available ? '' : ' disabled') + '>' +
          (isAdded ? ICON.check : ICON.plus) + '<span>' + esc(isAdded && cfg.added ? cfg.added : cfg.add) + '</span>' +
        '</button>' +
      '</div>';
    }

    function render() {
      var per = Math.max(1, cfg.per);
      var pages = Math.max(1, Math.ceil(items.length / per));
      if (page > pages - 1) page = pages - 1;
      if (page < 0) page = 0;
      list.innerHTML = items.slice(page * per, page * per + per).map(cardHtml).join('');
      if (nav) {
        nav.hidden = pages < 2;
        prev.disabled = page === 0;
        next.disabled = page >= pages - 1;
      }
    }

    function start(data) {
      items = (data || []).filter(function (p) {
        return p.id !== cfg.current && p.variants && p.variants.length && p.variants.some(function (v) { return v.available; });
      }).slice(0, cfg.max);

      if (!items.length) {
        if (window.Shopify && window.Shopify.designMode) {
          root.hidden = false;
          list.innerHTML = '<p class="fbt-empty">' + esc(cfg.empty) + '</p>';
          return;
        }
        root.hidden = true;
        return;
      }
      root.hidden = false;
      render();
    }

    if (prev) prev.addEventListener('click', function () { page--; render(); });
    if (next) next.addEventListener('click', function () { page++; render(); });

    /* Variant change inside a card */
    list.addEventListener('change', function (e) {
      var select = e.target.closest('select');
      if (!select) return;
      var card = select.closest('.fbt-card');
      var p = items.filter(function (x) { return String(x.id) === card.dataset.id; })[0];
      if (!p) return;
      var v = p.variants.filter(function (x) { return String(x.id) === select.value; })[0];
      if (!v) return;
      card.querySelector('.fbt-variant span').textContent = v.title;
      card.querySelector('.fbt-price').innerHTML = priceHtml(v);
      var btn = card.querySelector('.fbt-add');
      btn.dataset.variant = v.id;
      btn.disabled = !v.available;
    });
    /* FBT Add: adds the selected main-product variant plus this item; main is skipped if already in cart */ function fbtAddWithMain(fid) { var mi = document.querySelector('product-form form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"][id^="product-form"] [name="id"]'); var mv = mi ? Number(mi.value) : 0; var ab = mi && mi.form ? mi.form.querySelector('[name="add"]') : null; if (!cfg.withMain || !mv || mv === fid || (ab && ab.disabled)) return window.vcAddToCart(fid, 1); var qi = document.querySelector('[name="quantity"][form="' + mi.form.getAttribute('id') + '"]') || mi.form.querySelector('[name="quantity"]'); var mq = Math.max(1, parseInt(qi && qi.value, 10) || 1); return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { var has = (c.items || []).some(function (i) { return i.variant_id === mv; }); return has ? window.vcAddToCart(fid, 1) : window.vcAddToCart(mv, mq).then(function () { return window.vcAddToCart(fid, 1); }); }); }    /* Add button: spinner -> check, cart drawer opens, header count updates (no reload) */
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.fbt-add');
      if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
      var card = btn.closest('.fbt-card');
      setButton(btn, 'loading');
      fbtAddWithMain(Number(btn.dataset.variant))
        .then(function () {
          added[card.dataset.id] = true;
          setButton(btn, 'added');
          if (btn.animate) btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.08)' }, { transform: 'scale(1)' }], { duration: 300 });
        })
        .catch(function (err) {
          setButton(btn, 'idle');
          var t = btn.querySelector('span');
          t.textContent = err.message;
          setTimeout(function () { setButton(btn, added[card.dataset.id] ? 'added' : 'idle'); }, 2500);
        });
    });

    if (cfg.source === 'auto') {
      fetch(cfg.recUrl + '.json?product_id=' + cfg.current + '&limit=' + cfg.max + '&intent=' + cfg.intent)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          start((json.products || []).map(function (p) {
            var img = p.featured_image || '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
            return {
              id: p.id,
              title: p.title,
              url: p.url,
              image: img,
              variants: (p.variants || []).map(function (v) {
                return { id: v.id, title: v.title, price: v.price, compare: v.compare_at_price || 0, available: v.available };
              })
            };
          }));
        })
        .catch(function () { start([]); });
    } else {
      start(cfg.products);
    }
  }

  function initAll() { document.querySelectorAll('.vc-fbt').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
